import { isToday, isYesterday } from "date-fns";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../../../../core/auth/authSlice";
import { User } from "../../../../shared/models";

import ProfilePicture from "../../../../components/essentials/profile-picture/ProfilePicture";
import { UserPreviewInfo } from "../../../../components/essentials/user-card/UserCard";
import { selectMessages } from "../../../../core/auth/chatSlice";
import { capitalizeName } from "../../../../shared/utils/util";
import { IMessage } from "../message/Message";
import "./ChatBox.scss";

export interface ChatBoxProps {
	chatBoxInfo: ChatBoxInfo;
	index: number;
}

export interface ChatBoxInfo {
	id: string;
	other: UserPreviewInfo;
	lastMessage: IMessage;
}

const ChatBox: React.FC<ChatBoxProps> = ({ chatBoxInfo, index }) => {
	const { id, other, lastMessage } = chatBoxInfo;
	// const read = () => {
	//   if (info.read) return <div></div>;
	//   else return <div className="read"></div>;
	// };

	const { t } = useTranslation();
	const navigate = useNavigate();

	const { userId } = useSelector(selectUser) as User;

	const formatTime = (dateString: string) => {
		const date = new Date(dateString);

		if (isToday(date)) {
			const hour = date.getUTCHours();
			const minute = date.getUTCMinutes();
			return `${hour}:${String(minute).padStart(2, "0")}`;
		} else if (isYesterday(date)) {
			return "Yesterday";
		} else {
			const day = date.getDay();
			const month = date.getMonth() + 1;
			return `${day}/${month}`;
		}
	};

	const activeChatId = useSelector(selectMessages).activeChat.chatId;
	const { actorId } = useSelector(selectUser) as User;

	return (
		<div
			onClick={() => {
				navigate(`/messages/${id}`);
			}}
			className={`messageBox ${
				index % 2 == 0 ? "messageBox__darkGray3" : "messageBox__darkBlue1"
			}
        `}
		>
			{activeChatId === id && <div className="active-overlay" />}
			<div className="messageBox__pic-container">
				<ProfilePicture
					className="messageBox__pic"
					userId={other.id}
					avatarVersion={other.avatarVersion}
				/>
				{lastMessage && !lastMessage.read && lastMessage.sender !== actorId && (
					<div className="to-read-dot" />
				)}
			</div>
			{/* <div className="messageBox__content"> */}
			{/* <div className="messageBox__content-title"> */}
			<div className="messageBox-sender">
				<p>{capitalizeName(other.name)} {capitalizeName(other.surname)}</p>
			</div>

			{/* </div> */}
			<div
				className={`messageBox__message ${
					lastMessage && !lastMessage.read && lastMessage.sender !== actorId
						? "messageBox__message-unread"
						: "messageBox__message-read"
				} ${lastMessage && lastMessage.type === "system" ? "messageBox__message-system" : ""}`}
			>
				{lastMessage && (
					<p>
						{lastMessage.type === "post"
							? "🔁 Shared a post"
							: lastMessage.type === "system"
							? t(lastMessage.text, { name: `${capitalizeName(other.name)} ${capitalizeName(other.surname)}` })
							: `${userId == lastMessage.sender ? "You: " : ""}${lastMessage.text}`
						}
					</p>
				)}
			</div>
			{lastMessage && (
				<div className="messageBox__time">
					{formatTime(lastMessage.createdAt)}
				</div>
			)}
			{/*{read()} */}
		</div>
	);
};

export default ChatBox;
